(function () {
  'use strict';

  function hasClass(element, className) {
    return element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
  }

  function addClass(element, className) {
    if (!element || hasClass(element, className)) return;
    element.className += (element.className ? ' ' : '') + className;
  }

  function initOffers(section) {
    if (!section || section.getAttribute('data-mjl-initialized') === 'true') return;

    section.setAttribute('data-mjl-initialized', 'true');

    var cards = section.querySelectorAll('.mjl-offer-card');
    var stagger = parseInt(section.getAttribute('data-stagger'), 10);
    var index;

    if (isNaN(stagger)) stagger = 100;

    for (index = 0; index < cards.length; index += 1) {
      cards[index].style.transitionDelay = (index * stagger) + 'ms';
    }

    if (section.getAttribute('data-animation') !== 'true' || !window.IntersectionObserver) {
      addClass(section, 'mjl-is-visible');
      return;
    }

    var observer = new window.IntersectionObserver(function (entries) {
      var entryIndex;

      for (entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
        if (entries[entryIndex].isIntersecting) {
          addClass(section, 'mjl-is-visible');
          observer.unobserve(section);
          break;
        }
      }
    }, { threshold: 0.12 });

    observer.observe(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-mjl-offers]') : [];
    var index;

    if (scope.nodeType === 1 && scope.getAttribute && scope.getAttribute('data-mjl-offers') !== null) {
      initOffers(scope);
    }

    for (index = 0; index < sections.length; index += 1) {
      initOffers(sections[index]);
    }
  }

  function start() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
